import { render } from "./TabelaExercicios.vue?vue&type=template&id=4076044e"
import script from "./TabelaExercicios.vue?vue&type=script&lang=js"
export * from "./TabelaExercicios.vue?vue&type=script&lang=js"

import "./TabelaExercicios.vue?vue&type=style&index=0&id=4076044e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__